export enum RoutesPath {
    CATALOGUE = "/catalogue",
    BUY_MOTORCYCLES = "/buy-motorcycles",
    BUY_PARTS = "/buy-parts",
    REVIEWS = "/reviews",
    MOTO_GARAGES = "/moto-garages",
    MOTO_GARAGE_DETAILS = "/moto-garages/:id",
    CATALOGUE_DETAILS = "/catalogue/:id",
    CATALOGUE_COMPARE = "/catalogue/compare",
    FAVOURITES = "/favourites",
}
